import { Vector2 } from "three";
import { isClassOf } from "../../../library-js/tools/TypeUtilities";
import { NodeGraphNode } from "../model/NodeGraphNode";
import { NodeGraphEvent } from "./NodeGraphEvent";
import { NodeGraphInteraction } from "./NodeGraphInteraction";

export class NGMover extends NodeGraphInteraction
{
  _moving:boolean = false;
  _lastPosition:Vector2 = new Vector2();

  update( nge:NodeGraphEvent )
  {
    if ( this._moving  )
    {
      if ( nge.mouse.buttons[ 0 ].isDown )
      {
        this._moving = false;
        this.blur();

        return;
      }      

      this._moveSelected( nge );
    }

    if ( ! nge.mouse.buttons[ 0 ].isDown )
    {
      return;
    }


    if ( this.selection.isEmpty )
    {
      console.log( "NO SELECTION" );
      return;
    }


    let hoveredReference = nge.hoveredReference;

    if ( ! hoveredReference )
    {
      console.log( "NOTHING HOVERED" );
      return;
    }

    if ( ! isClassOf( hoveredReference.reference, NodeGraphNode ) )
    { 
      console.log( "NO NODE" );
      return;
    }
    
    if ( ! this.selection.has( hoveredReference.reference ) )
    {
      console.log( "NOT SELECTED" );
      return;
    }
    
    
    this._moving = true;
    this._lastPosition.copy( nge.localMousePosition );
    this.focus();
    
  }

  _moveSelected( nge:NodeGraphEvent )
  {
    let newPosition = nge.localMousePosition.clone();

    let delta = newPosition.clone().sub( this._lastPosition );

    this._lastPosition.copy( newPosition );

    console.log( "Moving:", delta );

    if ( delta.lengthSq() < 1 )
    {
      return;
    }

    this.selection.forAllNodes( n => n.move( delta ) );


  }
}